















































































































































import { Component, Inject, Mixins } from "vue-property-decorator";

// Mixins
import Context from "@/mixins/context";
import ClientMixin from "@/mixins/clientMixin";

// Types
import {
  IBasketProviderData,
  IBasketProviderMethods
} from "@/models/providers/baskets";
import { Location as VueLocation } from "vue-router";
import { AdminRoutes, ClientRoutes } from "@/data/enums/router";

@Component({
  components: {
    "profile-dropdown": () =>
      import("@/components/app/global/user/profileDropdown.vue")
  }
})
export default class BasketAvatar extends Mixins(Context, ClientMixin) {
  // Inject - Basket Provider

  @Inject({ from: "basketProviderData" })
  public readonly $basketData!: () => IBasketProviderData;

  public get basketData() {
    return this.$basketData();
  }

  @Inject({ from: "basketProviderMethods" })
  public readonly $basketMethods!: IBasketProviderMethods;

  // Data

  public clientRegisterRoute = ClientRoutes.REGISTER;

  // Computed

  public get client() {
    return this.$_.get(this.basketData, "client");
  }

  public get account() {
    return this.$_.get(this.basketData, "account");
  }

  public get basket() {
    return this.$_.get(this.basketData, "basket");
  }

  public get logoutRoute(): VueLocation {
    return {
      name: this.isAdmin ? AdminRoutes.LOGOUT : ClientRoutes.LOGOUT,
      params: {
        toast: this.$t("_.see_you_soon") as string
      }
    };
  }

  public get clientProfileRoute() {
    return {
      name: AdminRoutes.CLIENT_SETTINGS_PROFILE,
      params: {
        clientId: this.client.id
      }
    };
  }

  public get clientName() {
    return this.getClientName({
      client: this.client
    });
  }

  public get clientBasketsLink() {
    return {
      name: "adminClientBaskets",
      params: { clientId: this.client?.id || this.basketData.clientId }
    };
  }

  public get hasNonDefaultPricelist() {
    return (
      !this.$_.isEmpty(this.account) &&
      this.account.pricelist_id !== this.account.brand.pricelist_id
    );
  }
}
